import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { server } from "../server";
import Swal from "sweetalert2";
import OtpModal from "../Templates/OtpModal";
import CryptoJS from 'crypto-js';
import { Company_Id } from "../Helper";
import { Corporate_Id } from "../Helper";
import { Corporate_Name } from "../Helper";
import { Vendor_Id } from "../Helper";
import { Vendor_Name } from "../Helper";

import { decrypt } from "../data/decrypt";


function Registration() {
 useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encrypted = params.get('data');
    console.log('Encrypted query string:', encrypted);

    const decrypted = decrypt(encrypted);
    console.log('Decrypted query string:', decrypted);

    const parsedParams = new URLSearchParams(decrypted);

    setFormValue(prev => ({
      ...prev,
      Name: parsedParams.get('name') || "",
      Email: parsedParams.get('email') || "",
      MobileNo: parsedParams.get('mobile') || "",
      Gender: parsedParams.get('gender') || "",
      CorporateId: parsedParams.get('corporateId') || "",
      editable: parsedParams.get('editable') || ""
    }));
  }, []);

  
  const initialValues = {
      Name: "",
      Email: "",
      MobileNo: "",
      Gender:  "",
      editable: true,
      DeviceTokenId: "0",
      DeviceType: "Registration Web",
      UserPass: "",
      UserConfirmPass: "",
      CorporateId: "-1",
      CorporateName: "",
      VendorId: "2583",
      EmployeeID: "",
      CompanyId: "-1",
      OTP: "",
    };

    const [formvalue, setFormValue] = useState({
    Name: "",
    Email: "",
    MobileNo: "",
    Gender: "",
    DeviceTokenId: "0",
    DeviceType: "Registration Web",
    UserPass: "",
    UserConfirmPass: "",
    CorporateId: "-1",
    CorporateName: "",
    VendorId: "2583",
    EmployeeID: "",
    CompanyId: "-1",
    OTP: ""
  });
  

  const [showModal, setShowModal] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // const [formvalue, setFormValue] = useState(initialValues);

  const [SelectedCorporate, setSelectedCorporate] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);
  const [EnteredOTP, setEnteredOTP] = useState(false);
  const handChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formvalue, [name]: value });
    if (name === "CorporateId") {
      setSelectedCorporate(value);

      console.log("Selected Corporate ID:", value);
    }
    // console.log(formvalue);
  };

  const verifyOtp = (otp) => {
    if (otp.length === 6) {
      formvalue.OTP = otp;
      setEnteredOTP(true);
      userRegistration({ ...formvalue });
      // closeModal();
    } else {
      alert("Invalid OTP. Please enter a 6-digit code.");
    }
  };

  async function userRegistration(formvalue) {
    setIsRegistering(true); // Start loading spinner

    try {
      if (showModal === true) {
        formvalue.OTP = formvalue.OTP;
      } else {
        formvalue.OTP = "";
      }

      const selectedcorporatename = "";
      // formvalue.CorporateName = selectedcorporatename.options[selectedcorporatename.selectedIndex].text;

      //console.log("URLLLLLLLl:", `${server}/api/Siemens/Registration`);
      // console.log("Form Value:", formvalue);
      let result = await fetch(`${server}/api/Siemens/CorporateRegistration`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        // credentials: "include",
        body: JSON.stringify(formvalue),
      });

      result = await result.json();

      if (
        result.statusCode == 200 &&
        result.status === "Email/EmployeeId Already Exist"
      ) {
        Swal.fire("Invalid Input!", "Email/EmployeeId Already Exist", "error");
      } else if (result.statusMessage === "Mobile No. Already Exist") {
        Swal.fire("Error!", "Mobile No Already Registered", "error");
      } else if (result.status === "Invalid Email") {
  Swal.fire({
    icon: "warning",
    title: "Registration Required",
    html: `Your organization is not yet registered with us. 
           Please contact your admin or reach out to us at 
           <a href="https://refexmobility.com/business-commute/" target="_blank" style="color:#3085d6; text-decoration:underline;">
             https://refexmobility.com/business-commute/
           </a> to get started.`
  });
} else if (result.status === "OTP Sent to Emaial") {
        openModal();
      } else if (result.status === "Invalid OTP") {
        Swal.fire("Error!", "Invalid OTP, please Enter a Valid OTP", "error");
      } else if (result.status === "Inserted Successfully") {
        Swal.fire(
          "Success",
          "You’re all set! Get ready for smoother, safer, and smarter travel with Refex.",
          "success"
        );
        closeModal();
        setEnteredOTP(false);
        setFormValue(initialValues);
      }
    } catch (error) {
      Swal.fire(
        "Network Error",
        "Something went wrong. Please try again later.",
        "error"
      );
      console.error("Error during registration:", error);
    } finally {
      setIsRegistering(false); // Stop loading spinner
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormErrors(validate(formvalue));
    setIsSubmit(true);
  };
  useEffect(() => {
    //console.log(formErrors);
    // alert(EnteredOTP);
    // alert(showModal);
    if (
      Object.keys(formErrors).length == 0 &&
      IsSubmit &&
      EnteredOTP === false &&
      showModal === false
    ) {
      // alert(EnteredOTP);
      userRegistration(formvalue);
    }
  }, [formErrors]);

  const validate = (value) => {
    const errors = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const mobileNoRegex = /^[0-9]{10}$/; // Adjust the pattern as needed

    if (!value.Name) {
      errors.Name = "Name is required";
    }
    if (!value.Email) {
      errors.Email = "Email required";
    } else if (!emailRegex.test(value.Email)) {
      errors.Email = "This is not a valid email format";
    }
    // formErrors.EmployeeID
    // if (!value.EmployeeID) {
    //       errors.EmployeeID = "Employee Id is required";
    //     }
    if (!value.MobileNo) {
      errors.MobileNo = "Mobile No. required";
    } else if (!mobileNoRegex.test(value.MobileNo)) {
      errors.MobileNo = "Invalid Mobile No.";
    }
    if (!value.Gender) {
      errors.Gender = "Gender required";
    }

    // formErrors.CorporateId

    if (!value.UserPass) {
      errors.UserPass = "Password is required";
    } else if (value.UserPass.length < 8) {
      errors.UserPass = "Password must be at least 8 characters long";
    }
    if (!value.UserConfirmPass) {
      errors.UserConfirmPass = "Confirm password is required";
    }
    if (value.UserPass && value.UserPass !== value.UserConfirmPass) {
      errors.UserConfirmPass = "Passwords do not match";
      // alert("Password do not match");
    }
    // console.log(errors);
    return errors;
  };

  return (
    <div>
      <div className="hold-transition login-page">
        <form onSubmit={handleSubmit}>
          <div className="login-box">
            <div className="card card-outline card-warning">
              <div className="card-header text-center">
                <img
                  src="/dist/img/Refexnewlogo.png"
                  alt="logo"
                  style={{ width: "200px" }}
                />
              </div>
              <div className="card-body">
                {}

                <p className="login-box-msg">{formvalue.editable == "false" ? "Create Password" : "Register"}</p>
                <form>
                  <div className="input-group mb-1">
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      placeholder="Name"
                      name="Name"
                      value={formvalue.Name}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[0-9]/g, ""); // ✅ Removes numbers
                        handChange({ target: { name: "Name", value } });
                      }}
                      readOnly={(formvalue.Name != null && formvalue.Name !== "")  && formvalue.editable == "false"}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-user" />
                      </div>
                    </div>
                  </div>

                  <p className="text-danger">{formErrors.Name}</p>
                  <div className="input-group mb-3">
                    <input
                      type="email"
                      id="useremail"
                      className="form-control"
                      placeholder="Email"
                      name="Email"
                      value={formvalue.Email}
                      onChange={handChange}
                      readOnly={(formvalue.Email != null && formvalue.Email !== "") && formvalue.editable == "false"}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-envelope" />
                      </div>
                    </div>
                  </div>

                  <p className="text-danger">{formErrors.Email}</p>
                  <div className="input-group mb-3">
                    <input
                      id="usermobileno"
                      type="text"
                      className="form-control"
                      placeholder="Mobile No"
                      name="MobileNo"
                      value={formvalue.MobileNo}
                      readOnly={(formvalue.MobileNo != null && formvalue.MobileNo !== "" )&&  formvalue.editable == "false"}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        if (value.length <= 10) {
                          handChange({ target: { name: "MobileNo", value } });
                        }
                      }}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fa fa-mobile" />
                      </div>
                    </div>
                  </div>
                  <p className="text-danger">{formErrors.MobileNo}</p>
                  <div className="input-group mb-3"></div>
                  {/* <div className="input-group mb-3">
                    <input id='usermobileno' type="text" className="form-control" placeholder="Employee ID"
                      name="EmployeeID"
                      value={formvalue.EmployeeID}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fa fa-mobile" />
                      </div>
                    </div>
                  </div> */}

                  <p className="text-danger">{formErrors.EmployeeID}</p>
                  <div className="input-group mb-3">
                    {/* <input type="password" className="form-control" placeholder="Password" />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div> */}
                  
                    <select
                      id="usergender"
                      className="form-control"
                      name="Gender"
                      value={formvalue.Gender}
                      disabled={(formvalue.Gender != null && formvalue.Gender !== "")  &&  formvalue.editable == "false"}
                      onChange={handChange}
                    >
                      <option>Select your Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <p className="text-danger">{formErrors.Gender}</p>

                  <div className="input-group mb-3">
                    <input
                      id="userpassword"
                      type="password"
                      className="form-control"
                      placeholder="Create Password"
                      name="UserPass"
                      value={formvalue.UserPass}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-lock" />
                      </div>
                    </div>
                  </div>
                  <p className="text-danger">{formErrors.UserPass}</p>
                  <div className="input-group mb-3">
                    <input
                      id="userconfirmpassword"
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                      name="UserConfirmPass"
                      value={formvalue.UserConfirmPass}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-lock" />
                      </div>
                    </div>
                  </div>
                  <p className="text-danger">{formErrors.UserConfirmPass}</p>
                  {/* <div className="row">
                    <div className="col-8">     
                      <div className="icheck-primary">
                        <input type="checkbox" id="remember" />
                        <label htmlFor="remember">Remember Me</label>
                      </div>
                    </div>
                  </div> */}
                </form>
                <div className="social-auth-links text-center mt-2 mb-3"></div>

                {/* <p className="mb-0">
                  <button className="btn btn-warning btn-block">Register Now</button>
                </p> */}
                <p className="mb-0">
                  <button
                    className="btn btn-warning btn-block"
                    // onClick={handleRegisterClick}
                    disabled={isRegistering}
                  >
                    {isRegistering ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Registering...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </p>

                <div className="container mt-5">
                  {/* <button className="btn btn-success" onClick={openModal}>Enter OTP</button> */}
                  <OtpModal
                    show={showModal}
                    handleClose={closeModal}
                    verifyOtp={verifyOtp}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default Registration;
